var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m22.05 8.738h-14.653c-2.439 0-4.415 1.916-4.416 4.28v9.319c0 1.135.465 2.225 1.293 3.028a4.487 4.487 0 0 0 3.123 1.254h2.103c.1 0 .18.08.181.176v4.597a.6.6 0 0 0 .392.554c.234.09.502.032.675-.146l4.975-5.128a.184.184 0 0 1 .13-.055h6.19c2.44 0 4.416-1.917 4.417-4.281v-9.319c-.002-2.361-1.974-4.276-4.41-4.28z",
  stroke: "#003a70",
  strokeWidth: 2.34
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.414 15.226-2.27 2.223a.19.19 0 0 1 -.265 0l-2.267-2.218a1.34 1.34 0 0 1 0-1.922 1.41 1.41 0 0 1 1.965 0l.302.295a.19.19 0 0 0 .264 0l.307-.3a1.41 1.41 0 0 1 1.35-.37c.486.125.865.495.992.97a1.34 1.34 0 0 1 -.378 1.322m9.857 0-2.27 2.223a.19.19 0 0 1 -.265 0l-2.267-2.218a1.34 1.34 0 0 1 0-1.922 1.41 1.41 0 0 1 1.965 0l.301.295a.19.19 0 0 0 .265 0l.307-.3a1.41 1.41 0 0 1 1.35-.37c.486.125.865.495.992.97a1.34 1.34 0 0 1 -.378 1.322",
  fill: "#ff4438",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#003a70",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 0.936
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.072 3.23v3.69",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 10.072,
  cy: 1.384,
  rx: 1.408,
  ry: 1.384
}), /*#__PURE__*/React.createElement("path", {
  d: "m19.928 3.23v3.69",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.928,
  cy: 1.384,
  rx: 1.408,
  ry: 1.384
})), /*#__PURE__*/React.createElement("path", {
  d: "m2.942 16.731v-3.573h-2.24c-.1 0-.182.082-.182.182v3.21c0 .1.081.181.182.181zm23.665 0v-3.573h2.24c.1 0 .181.082.181.182v3.21c0 .1-.081.181-.182.181z",
  strokeWidth: 1.04
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.08 20.759c2.062.836 3.631 1.253 4.71 1.253 1.077 0 2.647-.417 4.708-1.253",
  strokeLinecap: "round",
  strokeWidth: 1.357
})));
var SvgBot = function SvgBot(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 30 34",
    width: 30,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bot.b917c61b.svg";
export { ForwardRef as ReactComponent };